<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span style="flex-shrink: 0">
          组织名称
        </span>
        <el-input v-model="search.partnerName" placeholder="请输入组织名称"></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <span> 组织类型 </span>
        <el-select clearable v-model="search.partnershipType" placeholder="请选择组织类型">
          <el-option v-for="item in orgTypeList" :key="item.code" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <el-button type="primary" size="medium" @click="searchDataBtnFun">查询</el-button>
        <el-button size="medium" @click="resetForm">重置</el-button>
      </el-col>
    </el-row>
    <div class="m-b-10">
      <el-button type="primary" size="medium" @click="addOrgFun">+&nbsp;创建组织</el-button>
    </div>
    <el-table ref="checktableData" :data="tableDataList" v-loading="tableDataLoading" @selection-change="handleSelectionChange"
      :reserve-selection="true" height="60vh">
      <el-table-column type="selection" min-width="50" align="center">
      </el-table-column>
      <el-table-column label="组织编号" prop="partnershipId" min-width="120" align="center"></el-table-column>
      <el-table-column label="组织类型" prop="partnershipTypeStr" min-width="100" align="center"></el-table-column>
      <el-table-column label="组织名称" prop="partnerName" min-width="200" align="center"></el-table-column>
      <el-table-column label="合作种类" prop="cooperationTypeStr" min-width="100" align="center"></el-table-column>
      <el-table-column label="联系方式" prop="contactInfo" min-width="100" align="center"></el-table-column>
      <el-table-column label="组织地址" prop="address" min-width="100" align="center"></el-table-column>
      <el-table-column label="操作" fixed="right" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click=editRowFun(scope.row)>编辑</el-button>
          <el-button type="text" @click=deleteRowFun(scope.row)>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper" :current-page.sync="search.pageNum" :page-size.sync="search.pageSize"
        :page-sizes="[10, 20]" :total="tableDataTotalNum">
      </el-pagination>
    </div>
    <AddOrEditOrg ref="addOrEditOrgRef" :orgTypeList="orgTypeList" @opera-success="getList()"></AddOrEditOrg>
  </div>
</template>
<script>
import AddOrEditOrg from './components/AddOrEditOrg'
export default {
  name: 'orgManage',
  components: {
    AddOrEditOrg
  },
  data () {
    return {
      /**
       * tableDataLoading 表格数据加载是否完毕
       * tableDataList 表格数据
       * search 表单查询数据
       * tableDataTotalNum 表格数据总数
       * allSelectedIds 所有选中的数据
       * unSelectedIds 所有未选中的id
       * orgTypeList 组织类型列表
       */
      tableDataLoading: false,
      tableDataList: [],
      search: {
        partnerName: '',
        partnershipType: '',
        pageSize: 10,
        pageNum: 1,
      },
      tableDataTotalNum: 0,
      allSelectedIds: [],
      unSelectedIds: [],
      orgTypeList: []
    }
  },
  created () {
    this.getOrgTypeList()
    this.getList()
  },
  methods: {
    // 表格选择改变
    handleSelectionChange (rows) {
      // console.log(rows)
    },
    searchDataBtnFun () {
      this.search.pageNum = 1
      this.getList()
    },
    // 页数改变
    handleSizeChange (val) {
      this.getList()
    },
    // 页码改变
    handleCurrentChange () {
      this.getList()
    },
    // 重置查询
    resetForm (formName) {
      this.search = {
        orgName: '',
        partnershipType: '',
        pageSize: 10,
        pageNum: 1,
      }
      this.getList()
    },
    // 创建组织
    addOrgFun () {
      this.$refs.addOrEditOrgRef.openDialog('add')
    },
    // 编辑
    editRowFun (row) {
      // console.log('===row===', row)
      let url = `/autoapp-recovery-server-auth/api/tbl-partner-management/getDetailByPartnershipId/${row.partnershipId}`
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          this.$refs.addOrEditOrgRef.openDialog('edit', res.data)
        }
      })
    },
    // 删除
    deleteRowFun (row) {
      const id = row.partnershipId
      if (id) {
        this.$dialog({
          title: '温馨提示',
          content: '是否要删除，删除后不可以恢复！',
          cancel_buttton: '否',
          ok_buttton: '是',
          width: '400px',
          footBtn: 'card',
          dialogType: 'delete',
          onOk: () => {
            const idList = [id]
            const url = '/autoapp-recovery-server-auth/api/tbl-partner-management/delete'
            this.HttpService.delete(`${url}?idList=${idList}`, {}).then(res => {
              if (res.statusCode === 200) {
                this.$message.success('删除成功')
                this.getList()
              } else {
                const tipMsg = res.message || '操作失败'
                this.$message.error(tipMsg)
              }
            })
          },
          onCancel: () => {
            console.log('cancel');
          }
        })
      }
    },
    // 获取组织类型列表
    getOrgTypeList () {
      const url = '/autoapp-recovery-server-auth/api/tbl-partner-management/partnershipType'
      this.HttpService.get(url).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          const resData = res.data || []
          this.orgTypeList = resData
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
      })
    },
    // 获取数据请求
    getList () {
      this.tableDataList = [];
      this.tableDataLoading = true;
      const url = '/autoapp-recovery-server-auth/api/tbl-partner-management/page'
      this.HttpService.post(url, this.search).then(res => {
        if (res.statusCode === 200)
          this.tableDataTotalNum = res.data.total
        if (res.data.length === 0) {
          this.$dialog({
            title: '温馨提示',
            content: '未查询到结果!',
            footBtn: false,
            width: '20%',
            dialogType: 'sighicon',
          })
        } else {
          this.tableDataList = res.data.records || []
          this.tableDataLoading = false
        }
      })
    },
  }
}
</script>


<style scoped lang="scss">
.flex {
  display: flex;
  align-items: center;
  padding: 0 20px;

  span {
    min-width: 100px;
  }
}

.row-bg {
  margin-bottom: 15px;
}

.dialog {
  padding: 20px;

  .dialog-footer {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/orgManage.vue